import { createFileRoute } from "@tanstack/react-router";
import SaintEmployers from "@/pages/SaintEmployers";
export const Route = createFileRoute("/saint-employers")({
  component: RouteComponent,
  head() {
    return {
      meta: [
        {
          title: "SAINT® TMS for Employers | Back to Work in 5 Days",
        },
        {
          name: "description",
          content:
            "Get employees struggling with depression and anxiety back to work in 5 days with SAINT® TMS. FDA-cleared, fMRI-guided accelerated depression treatment for.",
        },
        {
          property: "og:title",
          content: "SAINT® TMS for Employers | Back to Work in 5 Days",
        },
        {
          property: "og:description",
          content:
            "Get employees struggling with depression and anxiety back to work in 5 days with SAINT® TMS. FDA-cleared, fMRI-guided accelerated depression treatment for.",
        },
        {
          property: "og:url",
          content: "https://neurowellnesstms.com/saint-employers",
        },
        {
          property: "og:type",
          content: "website",
        },
        {
          name: "twitter:card",
          content: "summary_large_image",
        },
      ],
      links: [
        {
          rel: "canonical",
          href: "https://neurowellnesstms.com/saint-employers",
        },
      ],
    };
  },
});
function RouteComponent() {
  return <SaintEmployers />;
}
